import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreateWeeklyMenuData, UpdateWeeklyMenuData, weeklyMenusApi } from '@/services';

export const adminWeeklyMenusKeys = {
  all: ['admin', 'weekly-menus'] as const,
  list: () => [...adminWeeklyMenusKeys.all, 'list'] as const,
  detail: (id: string) => [...adminWeeklyMenusKeys.all, 'detail', id] as const,
};

export function useAdminWeeklyMenusListQuery() {
  return useQuery({
    queryKey: adminWeeklyMenusKeys.list(),
    queryFn: () => weeklyMenusApi.getAll(),
  });
}

export function useAdminWeeklyMenuQuery(id: string) {
  return useQuery({
    queryKey: adminWeeklyMenusKeys.detail(id),
    queryFn: () => weeklyMenusApi.getById(id),
    enabled: Boolean(id),
  });
}

export function useCreateWeeklyMenuMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateWeeklyMenuData) => weeklyMenusApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminWeeklyMenusKeys.all });
    },
  });
}

export function useUpdateWeeklyMenuMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateWeeklyMenuData }) => weeklyMenusApi.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: adminWeeklyMenusKeys.all });
      queryClient.invalidateQueries({ queryKey: adminWeeklyMenusKeys.detail(variables.id) });
    },
  });
}

export function useDeleteWeeklyMenuMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => weeklyMenusApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminWeeklyMenusKeys.all });
    },
  });
}
